import { render } from "./danh-sach-phuong-tien-da-van-hanh.vue?vue&type=template&id=d6a315b8&scoped=true"
import script from "./danh-sach-phuong-tien-da-van-hanh.vue?vue&type=script&lang=js"
export * from "./danh-sach-phuong-tien-da-van-hanh.vue?vue&type=script&lang=js"

import "./danh-sach-phuong-tien-da-van-hanh.vue?vue&type=style&index=0&id=d6a315b8&lang=scss&scoped=true"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6a315b8"]])

export default __exports__